"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Asynchronous;

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _formik = require("formik");

var _core = require("@material-ui/core");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _excluded = ["field", "form", "label", "fetchOptions", "getOptionSelected", "getOptionLabel", "fieldValue", "variant", "autoFocus"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var debug = process.env.DEBUG;
var useStyles = (0, _core.makeStyles)(function () {
  return {
    option: {
      '&[data-focus="true"]': {
        background: "lightgray"
      }
    }
  };
});

function useDebounce(callback, delay) {
  var debouncedFn = (0, _react.useCallback)((0, _lodash["default"])(function () {
    return callback.apply(void 0, arguments);
  }, delay), [delay] // will recreate if delay &/ callback changes
  );
  return debouncedFn;
}

function Asynchronous(props) {
  var classes = useStyles();

  var field = props.field,
      form = props.form,
      label = props.label,
      fetchOptions = props.fetchOptions,
      getOptionSelected = props.getOptionSelected,
      getOptionLabel = props.getOptionLabel,
      fieldValue = props.fieldValue,
      variant = props.variant,
      autoFocus = props.autoFocus,
      others = _objectWithoutProperties(props, _excluded);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = _react["default"].useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      options = _React$useState4[0],
      setOptions = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(""),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      query = _React$useState6[0],
      setQuery = _React$useState6[1];

  var _React$useState7 = _react["default"].useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      typing = _React$useState8[0],
      setTyping = _React$useState8[1];

  var _React$useState9 = _react["default"].useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      loading = _React$useState10[0],
      setLoading = _React$useState10[1];

  var errorText = (0, _formik.getIn)(form.touched, field.name) && (0, _formik.getIn)(form.errors, field.name);
  var debouncedFetchOptions = useDebounce(function (_ref) {
    var setOptions = _ref.setOptions,
        setLoading = _ref.setLoading,
        active = _ref.active,
        query = _ref.query;
    fetchOptions({
      setOptions: setOptions,
      setLoading: setLoading,
      active: active,
      query: query
    });
  }, 1000);

  _react["default"].useEffect(function () {
    var active = true; // if (!loading) {
    //   return undefined;
    // }

    fetchOptions && query !== "" && debouncedFetchOptions({
      setOptions: setOptions,
      setLoading: setLoading,
      active: active,
      query: query
    });
    return function () {
      active = false;
    };
  }, [query]);

  _react["default"].useEffect(function () {
    if (!open) {
      setOptions([]);
      setQuery("");
      setLoading(false);
    }
  }, [open, loading]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    fullWidth: true,
    error: !!errorText
  }, /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    classes: {
      option: classes.option
    },
    id: "asynchronous-autocomplete",
    autoSelect: true,
    autoHighlight: true,
    size: "small",
    open: open,
    onOpen: function onOpen() {
      setOpen(true);
    },
    onClose: function onClose() {
      setOpen(false);
    },
    getOptionSelected: getOptionSelected,
    getOptionLabel: getOptionLabel,
    options: options,
    loading: loading,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({}, params, {
        label: label,
        variant: variant || "standard",
        autoFocus: autoFocus || false,
        error: !!errorText,
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          endAdornment: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, loading ? /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        }),
        onBlur: function onBlur() {
          form.setFieldTouched(field.name, true);
        }
      }));
    },
    onChange: function onChange(e, v) {
      form.setFieldValue(field.name, v ? v : "");
    },
    value: field.value,
    onInputChange: function onInputChange(e, value, reason) {
      setLoading(true);

      if (reason === "input") {
        setQuery(value);
      }
    }
  }, others)), /*#__PURE__*/_react["default"].createElement(_core.FormHelperText, null, errorText)));
}